import React, { Component, PropTypes } from 'react';
import { Dialog, TextField, FlatButton, Card, CardHeader, CardText, Paper, IconButton, RaisedButton } from 'material-ui';
import { addLocation, removeLocation, updateSuppProfileProps, deleteGroup, reorderLocations, reorderProducts } from '../../../stores/profile/company/profile-actions';
import { addProduct, removeProduct } from '../../../stores/profile/location/location-actions';
import ReorderItems from './reorder-items';
import getClassNames from 'classnames';
import Icon from '../../tc-ui/icon';
import ListLink from './list-link';
import R, { contains, not, isNil, isEmpty, either, path } from 'ramda';
import ImportData from './importData';
import SearchBar from './locProdSearchBar';
import injectSheet from 'react-jss';
import GroupTemplateIcon from 'material-ui/svg-icons/content/link';
import ManageGroups from './manage-group';
import pluralize from "pluralize";
import { connect } from 'react-redux';

const isNilOrEmpty = either(isNil, isEmpty);

class LocationOrProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      removeItemDialog: false,
      removeItemFailedDialog: false,
      addItemDialog: false,
      confirmRemoveLocationAndProducts: false,
    };
  }

  componentWillUnmount = () => {
    const { profile, updateProps } = this.props;
    if (profile.searchValue) updateProps({ searchValue: '', filteredResults: [] });
  }

  _openAddItemDialog = () => {
    const { user, dispatch, isOneLocationSupplier } = this.props;
    if (this._showLocations() && !isOneLocationSupplier && !R.contains('createLocation', user.corporateAccess)) {
      dispatch({ type: 'GLOBAL_ERROR_TRIGGERED', payload: { noAccessDialog: true, requestingAccessToFeature: 'Create Location', requestAccessData: { type: 'corporateAccess' } } });
    } else {
      this.setState({
        newItemName: '',
      }, () => this.showDialog('addItemDialog'));
    }
  };

  _addItem = () => {
    const { dispatch, params, isOneLocationSupplier, singleLocId } = this.props;
    const { action, locationId } = (() => {
      if (this._showLocations() && !isOneLocationSupplier) return { action: addLocation };
      if (this._showProducts()) return { action: addProduct, locationId: params.locationId || singleLocId };
      return {};
    })();

    dispatch(action(this.state.newItemName, locationId))
      .then(() => this.dismissDialog('addItemDialog'))
      .catch((err) => {
        console.log('error', err);
        this.dismissDialog('addItemDialog');
        this.props.triggerSnackBarMessage({
          message: `Adding ${this._showLocations() ? 'Location' : 'Product' } Failed`,
        });
      });
  };

  _changeNewItemName = (event) => {
    this.setState({
      newItemName: event.target.value,
    });
  };

  _removeItem = () => {
    const { dispatch, params, isOneLocationSupplier, singleLocId } = this.props;
    const { action, locationId } = (() => {
      if (this._showLocations() && !isOneLocationSupplier) return { action: removeLocation };
      if (this._showProducts()) return { action: removeProduct, locationId: params.locationId || singleLocId };
      return {};
    })();
    this.dismissDialog('removeItemDialog');
    this.dismissDialog('confirmRemoveLocationAndProducts');
    dispatch(action(this.state.removeItem.id, locationId)).catch(err => {
      console.log('error in removing location/product', err);
      this.props.triggerSnackBarMessage({
        message: `Removing ${this._showLocations() ? 'Location' : 'Product' } Failed`,
      });
    });
  };

  _confirmRemoveItem = (item) => {
    if (item.numOfProducts) {
      this.setState({
        itemFailedName: item.name,
        removeItem: item,
      }, () => this.showDialog('confirmRemoveLocationAndProducts'));
    } else {
      this.setState({
        removeItem: item,
      }, () => this.showDialog('removeItemDialog'));
    }
  };

  _showProducts = () => {
    const { routeName, isOneLocationSupplier } = this.props;
    return routeName === 'location' || isOneLocationSupplier;
  };

  _showLocations = () => {
    const { routeName, isOneLocationSupplier } = this.props;
    return routeName === 'profile' && !isOneLocationSupplier;
  };

  dismissDialog = (modal) => {
    this.setState({ [modal]: false });
  };

  showDialog = (modal) => {
    this.setState({ [modal]: true });
  };

  getListComponent = (dataArray, item) => {
    return dataArray.map((locationOrProduct, index) => {
      const borderBottom = index === dataArray && dataArray.length - 1 ? null : '1px solid #efefef';
      return (
        <ListLink
          key={locationOrProduct.id}
          item={item}
          borderBottom={borderBottom}
          locationOrProduct={locationOrProduct}
          _confirmRemoveItem={this._confirmRemoveItem.bind(this, locationOrProduct)}
          {...this.props}
        />
      );
    })
  };
  render() {
    const classes = getClassNames('l-paper-split-location', this.props.className);
    const productType = this.props.user.company.productType; // Accommodation or Non-Accomodation
    let addLabel;
    let item;
    let title;
    let itemUppercase;
    let descText;
    let hintText;
    let locationsOrProducts;
    const filterdResults = R.pathOr([], ['profile', 'filteredResults'], this.props);
    if (this._showProducts()) {
      locationsOrProducts = !isNilOrEmpty(filterdResults) ? filterdResults : this.props.products;
      itemUppercase = 'Product';

      if (productType === 'Accommodation') {
        descText = 'A product would be one room type.';
        hintText = 'The City View Suite';
      } else {
        descText = 'For day tours, multi-day tours, cruises, transfers, and the likes, a product would be one tour or experience.\n\nFor attractions, museums, amusement parks, and the likes, a product would be one ticket.';
        hintText = 'New York Afternoon Walking Tour / Statue of Liberty General Admission';
      }
    } else if (this._showLocations()) {
      locationsOrProducts = !isNilOrEmpty(filterdResults) ? filterdResults : this.props.locations;
      itemUppercase = 'Location';
      if (productType === 'Accommodation') {
        descText = 'A location would be one property. You should title your location as your property name.';
        hintText = 'The Hilton Times Square';
        addLabel = 'Property';
      } else {
        descText = 'For day tours, multi-day tours, cruises, transfers, and the likes, a location would be one shop or one operating area.\n\nFor attractions, museums, amusement parks, and the likes, a location would be one property.';
        hintText = 'New York City & surrounds / Coney Island';
      }
    } else {
      return <div/>;
    }

    title = `${itemUppercase}s`;
    item = itemUppercase.toLowerCase();
    let addItemBorder;
    if (locationsOrProducts && locationsOrProducts.length) addItemBorder = '1px solid #efefef';

    const addItem = this.props.isEditable ? (
      <div
        className="location-name profile-image-add-container"
        onClick={this._openAddItemDialog}
      >
        <div style={{
          height: '80px',
          position: 'relative',
          display: 'block',
          clear: 'both',
          float: 'left',
          padding: '16px',
        }}
        >
          <div className="profile-image profile-image-add add-location-add-container">
            <div className="profile-image-letter add-location-add"> <Icon className="tc-icon-add"/> </div>
          </div>
        </div>
        <div style={{
          height: '48px',
          borderBottom: addItemBorder,
        }} className="location-content"
        >
          <h4 className="add-location-header" style={{
            height: '48px',
            lineHeight: '38px',
            verticalAlign: 'middle',
          }}
          > Add {addLabel || itemUppercase} </h4>
        </div>
      </div>
    ) : null;

    const removeItemActions = [
      <FlatButton label="Cancel" secondary onClick={() => this.dismissDialog('removeItemDialog')} />,
      <FlatButton label="Confirm" primary onTouchTap={this._removeItem} />,
    ];
    const allIdsInGroups = R.chain(R.prop('items'), this.props.groups || [])

    return (
      <div className={this.props.className} id={'prodAnchor'}>
        <Paper>
          <div
            className={`${this.props.classes.titleBar} flex-tc-sb`}
          >
            {title}
            {
              this.props.isEditable && (
                <div>
                  <RaisedButton
                    label="Create Group"
                    onTouchTap={() => this.props.updateProps({
                      manageGroupOpen: true,
                      groupToManage: {
                        owner_id: this.props.profileToShow.id,
                        type: item === 'location' ? 'locGroup' : 'prodGroup',
                        owner_type: item === 'location' ? 'Supplier' : 'Location',
                      },
                    })}
                  />

                  <RaisedButton
                    label="Reorder"
                    style={{ marginLeft: '8px' }}
                    onTouchTap={() => this.props.updateProps({
                      reorderItemsOpen: true,
                    })}
                  />
                </div>
              )
            }
          </div>
          {this.props.isEditable ? <SearchBar locOrProd={item} allLocOrProd={this._showLocations() ? this.props.locations : this.props.products}/> : <span/>}
          <div style={{
            overflowY: 'scroll',
            maxHeight: '440px',
            overflowX: 'hidden',
            marginTop: '0px',
          }} className={classes} ref="locationList"
          >
            {addItem}
            {
              Boolean(this.props.groups && this.props.groups.length) && this.props.groups.map(group => {
                const forThisGroup = locationsOrProducts.filter(obj => group.items.indexOf(obj.id) > -1);
                return (
                  <Card key={group.tag} expandable>
                    <CardHeader
                      showExpandableButton
                      actAsExpander
                      style={{ padding: '6px' }}
                      textStyle={{ display: 'none' }}
                    >
                      <div className={(this.props.classes.container)}>
                        <div className={(this.props.classes.texts)}>
                          <div className={(this.props.classes.groupName)}>
                            <GroupTemplateIcon color="rgba(0, 0, 0, 0.65)" style={{ marginRight: '4px' }}/>
                            {group.tag}
                          </div>
                          <div className={(this.props.classes.subTitle)}>
                            {`${forThisGroup.length} ${pluralize(item, forThisGroup.length)}`}
                          </div>
                        </div>
                        {
                          Boolean(this.props.isEditable) && (
                            <IconButton
                              iconClassName="tc-icon-mode_edit"
                              iconStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
                              style={{ padding: '0', width: '36px', height: '24px' }}
                              tooltip="Edit Group"
                              tooltipPosition="top-right"
                              onTouchTap={() => this.props.updateProps({
                                manageGroupOpen: true,
                                groupToManage: { groupId: group._id, groupName: group.tag, items: forThisGroup },
                              })}
                            />
                          )
                        }
                      </div>
                    </CardHeader>
                    <CardText expandable>
                      {this.getListComponent(forThisGroup, item)}
                    </CardText>
                  </Card>
                )
              })
            }
            {Boolean(locationsOrProducts) && this.getListComponent(locationsOrProducts.filter(obj => allIdsInGroups.indexOf(obj.id) === -1), item)}
          </div>
        </Paper>
        <Dialog
          className="form-dialog"
          ref="removeItemDialog"
          title={`Are you sure you want to remove this ${item}?`}
          actions={removeItemActions}
          open={this.state.removeItemDialog}
        >
          {`Are you sure you want to remove this ${item}?`}
        </Dialog>
        <Dialog
          className="form-dialog"
          ref="removeItemFailedDialog"
          title={`Deleting the ${itemUppercase} "${this.state.itemFailedName}" Failed`}
          actions={[
            <FlatButton
              label="OK"
              onTouchTap={() => this.dismissDialog('removeItemFailedDialog')}
              secondary
            />,
          ]}
          open={this.state.removeItemFailedDialog}
        >
          {`If you want to remove ${this.state.itemFailedName}, first remove its products.`}
        </Dialog>
        <Dialog
          className="form-dialog"
          ref="confirmRemoveLocationAndProducts"
          title={`Deleting this ${itemUppercase} Will Delete All Products For "${this.state.itemFailedName}"`}
          actions={[
            <FlatButton label="Cancel" secondary onClick={() => this.dismissDialog('confirmRemoveLocationAndProducts')} />,
            <FlatButton label="Confirm" primary onTouchTap={this._removeItem} />,
          ]}
          open={this.state.confirmRemoveLocationAndProducts}
        >
          {`Are you sure you want to delete ${this.state.itemFailedName} and all its products?`}
        </Dialog>
        <Dialog
          className="form-dialog"
          title={`What is the name of your ${item}?`}
          ref="addItemDialog"
          open={this.state.addItemDialog}
        >
          <span style={{ whiteSpace: 'pre-wrap', fontSize: '12px' }}>
          {descText}
          </span>
          <br/>
          <TextField
            value={this.state.newItemName}
            floatingLabelText={`${itemUppercase} Name`}
            hintText={hintText}
            onChange={this._changeNewItemName}
            style={{ width: '100%' }}
          />
          <br/>
          <br/>
          <div style={{ textAlign: 'right', clear: 'both' }}>
            <FlatButton
              style={{ marginRight: '8px' }}
              label="Cancel"
              type="button"
              secondary
              disableTouchRipple
              disableFocusRipple
              onClick={() => this.dismissDialog('addItemDialog')}
            />
            <FlatButton
              label="Add"
              type="button"
              disabled={!this.state.newItemName}
              primary={Boolean(this.state.newItemName)}
              disableTouchRipple
              disableFocusRipple
              onClick={this._addItem}
            />
          </div>
        </Dialog>
        <ImportData
          locOrProd={item}
          params={this.props.params}
        />
        <ManageGroups
          open={Boolean(this.props.profile.manageGroupOpen)}
          savingGroup={Boolean(this.props.profile.savingGroup)}
          onRequestClose={() => this.props.updateProps({ manageGroupOpen: false, groupToManage: {} })}
          dataArray={item === 'location' ? this.props.locations : this.props.products}
          groupToManage={this.props.profile.groupToManage}
          deleteGroup={this.props.deleteGroup}
          type={item}
        />
        <ReorderItems
          open={Boolean(this.props.profile.reorderItemsOpen)}
          savingChanges={Boolean(this.props.profile.savingReorderChanges)}
          onRequestClose={() => this.props.updateProps({ reorderItemsOpen: false })}
          items={item === 'location' ? this.props.locations : this.props.products}
          updateOrder={item === 'location' ? this.props.reorderLocations : this.props.reorderProducts}
        />
      </div>
    );
  }
}


LocationOrProduct.propTypes = {
  dispatch: PropTypes.func,
  params: PropTypes.object,
  className: PropTypes.string,
  triggerSnackBarMessage: PropTypes.func,
  routeName: PropTypes.string,
  isEditable: PropTypes.bool,
  user: PropTypes.object,
  products: PropTypes.array,
  locations: PropTypes.array,
  isOneLocationSupplier: PropTypes.bool,
  singleLocId: PropTypes.string,
  profile: PropTypes.object,
  groups: PropTypes.array,
  classes: PropTypes.object,
  updateProps: PropTypes.func,
  deleteGroup: PropTypes.func,
  reorderLocations: PropTypes.func,
  reorderProducts: PropTypes.func,
};



const styles = {
  titleBar: {
    fontSize: '20px',
    backgroundColor: '#f5f5f5',
    height: '48px',
    padding: '0 16px',
  },
  container: { height: '56px', display: 'flex', paddingLeft: '16px', alignItems: 'center', width: '93%', justifyContent: 'space-between' },
  texts: { width: '75%', color: 'rgba(0, 0, 0, 0.77)', cursor: 'pointer' },
  groupName: { fontSize: '14px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', width: '90%', display: 'flex', alignItems: 'center' },
  subTitle: { fontSize: '13px', marginLeft: '28px', color: '#00bcd4' },
};

export default connect(null, {
  updateProps: updateSuppProfileProps,
  deleteGroup,
  reorderLocations,
  reorderProducts,
})(injectSheet(styles)(LocationOrProduct));

/* jshint ignore:end */



// WEBPACK FOOTER //
// ./src/app/components/profile/location-or-product-list/company-location.jsx